import { IAddHoliday } from '../../models/forms/IAddEditHoliday';

const HolidayInitialState: IAddHoliday = {
  TenantId: -1,
  HolidayName: '',
  Comment: '',
  HolidayDate: new Date(),
  Year: new Date().getFullYear(),
};

export default HolidayInitialState;
